import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import { StatefulTooltip } from 'baseui/tooltip'

import { StyledSidebarButton, StyledSidebarLabel, tooltipOverrides } from '../styled-components'
import IconCarbonUnknown from '@/shared/icons/IconCarbonUnknown'
import RailHoverBubble from '@/shared/components/RailHoverBubble/RailHoverBubble'
import useRailHoverLabel from '@/shared/components/RailHoverBubble/useRailHoverLabel'
import { RAIL_ICON_SIZE } from '@/shared/theme/railSlot'

const SidebarButton = ({ classes, clickHandler, icon, isSelected, text, url, floating = false, expanded = false }) => {
  const [, theme] = useStyletron()
  const { anchorRef, geometry, show, hide } = useRailHoverLabel()
  const iconProps = {
    size: floating ? RAIL_ICON_SIZE : 24,
    color: isSelected && !floating ? theme.colors.white : theme.colors.primary,
    title: '',
  }
  const button = (
    <StyledSidebarButton
      ref={anchorRef}
      className={classes}
      onClick={clickHandler ?? null}
      onMouseEnter={floating ? show : undefined}
      onMouseLeave={floating ? hide : undefined}
      $isSelected={isSelected ?? false}
      $floating={floating}
      $expanded={expanded}
      href={url}
    >
      {icon ? icon(iconProps) : <IconCarbonUnknown {...iconProps} />}
      <StyledSidebarLabel hidden={!expanded}>{text}</StyledSidebarLabel>
    </StyledSidebarButton>
  )

  if (expanded) return button

  if (floating) {
    return (
      <>
        {button}
        <RailHoverBubble geometry={geometry} label={text} />
      </>
    )
  }

  return (
    <StatefulTooltip content={text} popoverMargin={8} overrides={tooltipOverrides()}>
      {button}
    </StatefulTooltip>
  )
}

SidebarButton.propTypes = {
  classes: PropTypes.string,
  clickHandler: PropTypes.func,
  expanded: PropTypes.bool,
  floating: PropTypes.bool,
  icon: PropTypes.func,
  isSelected: PropTypes.bool,
  text: PropTypes.string.isRequired,
  url: PropTypes.string,
}

export default SidebarButton
